/**
 * Frame-rate-independent meter smoothing (fast rise, slower fall).
 * Operates on post-curve 0..1 meter levels.
 */

/** Per-second approach rates toward a higher / lower target. */
const ATTACK = 36;
const RELEASE = 14;

export function smoothMeterLevel(current: number, target: number, dtSec: number): number {
  if (!(dtSec > 0)) {
    return current;
  }
  const rate = target > current ? ATTACK : RELEASE;
  const alpha = 1 - Math.exp(-rate * dtSec);
  const next = current + (target - current) * alpha;
  if (next < 0.001 && target < 0.001) {
    return 0;
  }
  return next;
}

/** Track wall-clock delta between rAF paints (capped so tab-resume doesn't slam). */
export function createMeterClock(): { dt(): number; reset(): void } {
  let last = 0;
  return {
    dt() {
      const now = performance.now();
      const raw = last === 0 ? 1 / 60 : (now - last) / 1000;
      last = now;
      return Math.min(0.05, Math.max(0, raw));
    },
    reset() {
      last = 0;
    },
  };
}
